import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getUserToken } from '../common/resubale-functions';

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (getUserToken()) {
        return <Component />;
      }
      // Build the full current URL (pathname + search) to preserve query params
      const currentUrl = props.location.pathname + props.location.search;
      const redirectUrl = `/?redirectTo=${encodeURIComponent(currentUrl)}`;
      return (
        <Redirect to={redirectUrl} />
      );
    }}
  />
);

export default ProtectedRoute;
